// Vidéos réutilisées du portfolio principal (case studies)
const V = {
    ellieAttia:
        "https://customer-assets.emergentagent.com/job_linkedin-content-hub-3/artifacts/qllhtsbj_Ellie%20Attia%20Banque%20privee%20video%20short%20ceo.mp4",
    ellieAtia2:
        "https://customer-assets.emergentagent.com/job_linkedin-content-hub-3/artifacts/cuscky13_Ellie%20Atia%202%20Video%20Short%20Dirigeants.mp4",
    edouard:
        "https://customer-assets.emergentagent.com/job_linkedin-content-hub-3/artifacts/t9ty6961_Edouard%20Bauman%20Video%20ecrite%20par%20Fabien%20Moutier%20Personnal%20Branding%20.mp4",
    morgan: "/videos/morgan-real-estate.mp4",
    daniele: "/videos/daniele-zidane.mp4",
};

export const EXPERTISES = [
    {
        slug: "banque-privee",
        label: "Banques privées",
        navLabel: "Banque privée",
        metaTitle:
            "Personal Branding Banque Privée — Shorts & vidéos courtes LinkedIn | Brand Your Expertise",
        metaDescription:
            "Personal branding pour banquiers privés et dirigeants de banques privées. Shorts et vidéos courtes LinkedIn écrites et pilotées de A à Z par Fabien Moutier. Générez des rendez-vous qualifiés.",
        keywords:
            "personal branding banque privée, shorts vidéos banque privée, vidéos courtes banquier privé, vidéo LinkedIn dirigeant banque privée",
        eyebrow: "Expertise · Banques privées",
        h1: "Personal branding pour",
        h1Accent: "banques privées",
        intro:
            "Dans la banque privée, la confiance se gagne avant le premier rendez-vous. Les shorts et vidéos courtes LinkedIn transforment votre expertise patrimoniale en autorité visible — et vos prospects en clients qui vous connaissent déjà.",
        bullets: [
            "Un discours de conformité transformé en messages clairs et humains.",
            "Des vidéos courtes qui installent la confiance auprès d'une clientèle fortunée.",
            "Une présence LinkedIn qui attire des mandats sans prospection agressive.",
        ],
        caseStudies: [
            {
                client: "Ellie Attia",
                tag: "CEO · Banque privée",
                country: "Suisse",
                videoSrc: V.ellieAttia,
                realisation: "Agence Personnelle",
                instagram: "https://www.instagram.com/elieattia.fr/",
            },
            {
                client: "Ellie Attia",
                tag: "Short · Dirigeants",
                country: "Suisse",
                videoSrc: V.ellieAtia2,
                realisation: "Agence Personnelle",
                instagram: "https://www.instagram.com/elieattia.fr/",
            },
        ],
        faq: [
            {
                q: "Le personal branding est-il compatible avec la conformité en banque privée ?",
                a: "Oui. Chaque script est écrit avec vous et validé avant tournage. On parle d'expertise et de vision, jamais de conseil personnalisé ou de performance.",
            },
            {
                q: "Combien de vidéos courtes par mois pour un banquier privé ?",
                a: "Une demi-journée de tournage produit généralement 20 à 24 shorts, soit plusieurs semaines de présence LinkedIn régulière.",
            },
        ],
    },
    {
        slug: "gestion-de-patrimoine",
        label: "Conseillers en gestion de patrimoine",
        navLabel: "Gestion de patrimoine",
        metaTitle:
            "Personal Branding Gestion de Patrimoine — Shorts & vidéos courtes | Brand Your Expertise",
        metaDescription:
            "Personal branding pour conseillers en gestion de patrimoine. Shorts et vidéos courtes LinkedIn écrites par Fabien Moutier pour attirer des clients qualifiés et générer des rendez-vous.",
        keywords:
            "personal branding gestion de patrimoine, shorts vidéos conseiller patrimoine, vidéos courtes CGP, vidéo LinkedIn gestion de patrimoine",
        eyebrow: "Expertise · Gestion de patrimoine",
        h1: "Personal branding pour",
        h1Accent: "conseillers en gestion de patrimoine",
        intro:
            "Votre valeur ajoutée est invisible tant que vous ne l'expliquez pas. Les vidéos courtes LinkedIn rendent votre pédagogie patrimoniale concrète, rassurante et mémorable — pour attirer les bons clients.",
        bullets: [
            "Vulgariser fiscalité, prévoyance et transmission en 45 secondes.",
            "Sortir du lot dans un métier où tout le monde dit la même chose.",
            "Un flux régulier de leads entrants qualifiés via LinkedIn.",
        ],
        caseStudies: [
            {
                client: "Ellie Attia",
                tag: "Gestion de patrimoine",
                country: "Suisse",
                videoSrc: V.ellieAttia,
                realisation: "Agence Personnelle",
                note: "Plus de 40 vidéos conçues pour Ellie Attia",
                linkedin: "",
                instagram: "https://www.instagram.com/elieattia.fr/",
                context: "",
                participation: "",
                resultats: "",
            },
            {
                client: "La Fabrique du Patrimoine",
                tag: "Gestion de patrimoine",
                country: "France",
                videoSrc: null,
                realisation: "Studio partenaire",
                linkedin: "",
                instagram: "https://www.instagram.com/lafabriquedupatrimoine_/",
                context: "",
                participation: "",
                resultats: "",
            },
            {
                client: "Alon Attal",
                tag: "Gestion de patrimoine",
                country: "France",
                videoSrc: null,
                realisation: "Studio partenaire",
                linkedin: "",
                instagram: "https://www.instagram.com/alonattal/",
                context: "",
                participation: "",
                resultats: "",
            },
        ],
        faq: [
            {
                q: "Sur quels sujets un CGP peut-il faire des vidéos courtes ?",
                a: "Transmission, fiscalité, prévoyance, immobilier, idées reçues : je définis avec vous des angles à forte valeur qui parlent à vos clients cibles.",
            },
            {
                q: "Faut-il être à l'aise face caméra ?",
                a: "Non. Je suis présent au tournage avec prompteur et direction : vous lisez, vous validez, on s'occupe du reste.",
            },
        ],
    },
    {
        slug: "immobilier",
        label: "Professionnels de l'immobilier",
        navLabel: "Immobilier",
        metaTitle:
            "Personal Branding Immobilier — Shorts & vidéos courtes LinkedIn | Brand Your Expertise",
        metaDescription:
            "Personal branding pour professionnels de l'immobilier. Shorts et vidéos courtes qui génèrent des mandats et des rendez-vous. Écriture et stratégie Fabien Moutier.",
        keywords:
            "personal branding immobilier, shorts vidéos immobilier, vidéos courtes agent immobilier, vidéo LinkedIn immobilier",
        eyebrow: "Expertise · Immobilier",
        h1: "Personal branding pour",
        h1Accent: "l'immobilier",
        intro:
            "L'immobilier est un métier de réputation. Les shorts et vidéos courtes vous positionnent comme la référence locale, attirent les mandats et raccourcissent le cycle de décision de vos clients.",
        bullets: [
            "Devenir le visage incontournable de votre marché.",
            "Des vidéos qui génèrent des mandats vendeurs et acquéreurs.",
            "Une image premium alignée avec vos biens d'exception.",
        ],
        caseStudies: [
            {
                client: "Morgan Real Estate",
                tag: "Immobilier",
                country: "Belgique",
                videoSrc: V.morgan,
                realisation: "Studio Next Door",
            },
            {
                client: "Nouveau case study",
                tag: "Immobilier premium",
                country: "Suisse",
                videoSrc: null,
                realisation: "Studio partenaire",
            },
        ],
        faq: [
            {
                q: "Les vidéos courtes fonctionnent-elles pour vendre des biens ?",
                a: "Elles ne vendent pas un bien : elles vous vendent vous. Une fois positionné comme l'expert de votre zone, les mandats arrivent naturellement.",
            },
            {
                q: "Peut-on tourner sur mes biens plutôt qu'en studio ?",
                a: "Oui, le tournage peut se faire sur site ou en studio à Lausanne / Genève, selon l'image que vous voulez projeter.",
            },
        ],
    },
    {
        slug: "coach",
        label: "Coachs & consultants",
        navLabel: "Coach",
        metaTitle:
            "Personal Branding Coach — Shorts & vidéos courtes LinkedIn | Brand Your Expertise",
        metaDescription:
            "Personal branding pour coachs et consultants. Shorts et vidéos courtes LinkedIn écrites par Fabien Moutier pour construire l'autorité et remplir votre agenda de rendez-vous.",
        keywords:
            "personal branding coach, shorts vidéos coach, vidéos courtes consultant, vidéo LinkedIn coaching",
        eyebrow: "Expertise · Coachs & consultants",
        h1: "Personal branding pour",
        h1Accent: "coachs & consultants",
        intro:
            "Votre business dépend de votre crédibilité perçue. Les vidéos courtes LinkedIn démontrent votre méthode, créent la préférence et transforment votre audience en clients qui réservent un appel.",
        bullets: [
            "Prouver votre expertise au lieu de la revendiquer.",
            "Créer un lien de confiance avant même le premier échange.",
            "Un tunnel d'acquisition qui tourne sans publicité.",
        ],
        caseStudies: [
            {
                client: "Daniele Talata",
                tag: "Personal Branding · Sport",
                country: "France",
                videoSrc: V.daniele,
                realisation: "Brand Your Expertise",
            },
            {
                client: "Nouveau case study",
                tag: "Coaching",
                country: "Suisse",
                videoSrc: null,
                realisation: "Studio partenaire",
            },
        ],
        faq: [
            {
                q: "Comment se démarquer dans un marché du coaching saturé ?",
                a: "Par un positionnement signature et des angles précis. J'écris chaque script à votre voix pour une ligne éditoriale unique et reconnaissable.",
            },
            {
                q: "Combien de temps avant de voir des résultats ?",
                a: "La régularité prime. Avec 20+ shorts par tournage, vous alimentez plusieurs semaines de contenu et bâtissez une autorité durable.",
            },
        ],
    },
    {
        slug: "chirurgien",
        label: "Chirurgiens & médecins",
        navLabel: "Chirurgien",
        metaTitle:
            "Personal Branding Chirurgien — Shorts & vidéos courtes | Brand Your Expertise",
        metaDescription:
            "Personal branding pour chirurgiens et médecins. Shorts et vidéos courtes LinkedIn pédagogiques et éthiques, écrites par Fabien Moutier, pour asseoir votre autorité et attirer les bons patients.",
        keywords:
            "personal branding chirurgien, shorts vidéos médecin, vidéos courtes chirurgien, vidéo LinkedIn santé",
        eyebrow: "Expertise · Chirurgiens & médecins",
        h1: "Personal branding pour",
        h1Accent: "chirurgiens & médecins",
        intro:
            "La confiance est le premier acte médical. Les vidéos courtes LinkedIn rendent votre expertise accessible, rassurent vos futurs patients et vous distinguent avec sobriété et sérieux.",
        bullets: [
            "Vulgariser un acte technique sans jamais tomber dans la promesse.",
            "Rassurer et humaniser la relation avant la consultation.",
            "Une image d'autorité alignée avec votre exigence.",
        ],
        caseStudies: [
            {
                client: "Nouveau case study",
                tag: "Chirurgie",
                country: "Suisse",
                videoSrc: null,
                realisation: "Studio partenaire",
            },
        ],
        faq: [
            {
                q: "Le personal branding est-il déontologiquement acceptable pour un médecin ?",
                a: "Oui, à condition de rester pédagogique et sans promesse de résultat. Chaque script est écrit avec vous et validé pour respecter votre cadre déontologique.",
            },
            {
                q: "Quels sujets aborder en vidéo courte ?",
                a: "Prévention, idées reçues, parcours de soin, coulisses du métier : des angles qui informent et créent la confiance.",
            },
        ],
    },
    {
        slug: "avocat",
        label: "Avocats & cabinets",
        navLabel: "Avocat",
        metaTitle:
            "Personal Branding Avocat — Shorts & vidéos courtes LinkedIn | Brand Your Expertise",
        metaDescription:
            "Personal branding pour avocats et cabinets. Shorts et vidéos courtes LinkedIn écrites par Fabien Moutier pour démontrer votre expertise et générer des rendez-vous clients qualifiés.",
        keywords:
            "personal branding avocat, shorts vidéos avocat, vidéos courtes cabinet avocat, vidéo LinkedIn juridique",
        eyebrow: "Expertise · Avocats & cabinets",
        h1: "Personal branding pour",
        h1Accent: "avocats & cabinets",
        intro:
            "Le droit se choisit sur la confiance et la clarté. Les vidéos courtes LinkedIn traduisent votre expertise juridique en messages compréhensibles qui attirent des clients et des dossiers à forte valeur.",
        bullets: [
            "Rendre le juridique clair, concret et rassurant.",
            "Vous positionner comme la référence de votre spécialité.",
            "Attirer des dossiers qualifiés sans démarchage.",
        ],
        caseStudies: [
            {
                client: "Nouveau case study",
                tag: "Droit des affaires",
                country: "Suisse",
                videoSrc: null,
                realisation: "Studio partenaire",
            },
        ],
        faq: [
            {
                q: "La communication vidéo est-elle compatible avec la déontologie de l'avocat ?",
                a: "Oui. On reste sur de la pédagogie et du positionnement, jamais de la sollicitation personnalisée. Les scripts sont validés avec vous.",
            },
            {
                q: "Quels sujets pour un avocat sur LinkedIn ?",
                a: "Décryptage d'actualité juridique, erreurs fréquentes, cas d'usage : des angles utiles qui démontrent votre maîtrise.",
            },
        ],
    },
    {
        slug: "beaute",
        label: "Beauté & gérantes de salons",
        navLabel: "Beauté",
        metaTitle:
            "Personal Branding Beauté — Shorts & vidéos courtes LinkedIn | Brand Your Expertise",
        metaDescription:
            "Personal branding pour gérantes de chaînes de salons et entrepreneures beauté. Shorts et vidéos courtes écrites par Fabien Moutier pour développer votre marque et remplir vos salons.",
        keywords:
            "personal branding beauté, shorts vidéos salon beauté, vidéos courtes gérante salon, vidéo LinkedIn entrepreneure beauté",
        eyebrow: "Expertise · Beauté & salons",
        h1: "Personal branding pour",
        h1Accent: "gérantes de salons & beauté",
        intro:
            "Derrière une chaîne de salons, il y a une vision d'entrepreneure. Les vidéos courtes LinkedIn racontent votre marque, attirent talents et partenaires, et donnent envie à vos clientes de revenir.",
        bullets: [
            "Incarner votre marque et fédérer autour de votre vision.",
            "Attirer les meilleurs talents et partenaires du secteur.",
            "Transformer votre notoriété en trafic salon et en franchises.",
        ],
        caseStudies: [
            {
                client: "Nouveau case study",
                tag: "Beauté · Réseau de salons",
                country: "Suisse",
                videoSrc: null,
                realisation: "Studio partenaire",
            },
        ],
        faq: [
            {
                q: "LinkedIn est-il pertinent pour un business beauté ?",
                a: "Pour la dirigeante, oui : recrutement, partenariats, franchises et image de marque se jouent sur LinkedIn autant que sur Instagram.",
            },
            {
                q: "Peut-on décliner les vidéos sur Instagram et TikTok ?",
                a: "Oui, les shorts sont tournés en format vertical, prêts à être diffusés sur LinkedIn, Instagram et TikTok.",
            },
        ],
    },
];

export const getExpertise = (slug) =>
    EXPERTISES.find((e) => e.slug === slug);
